(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 5557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(1673);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* binding */ config; },
  "r": function() { return /* binding */ configSet; }
});

;// CONCATENATED MODULE: ./public/logo.png
/* harmony default export */ var logo = ({"src":"/_next/static/media/logo.ad9b92b2.png","height":512,"width":512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAY1BMVEVMaXFCgbsQRIZOd6F2gFtCkMW/pioFQpEAEzYiVYFKZWfywQ+ckD0qaZw3frI0eKwydaksbaAAMG5sjauguNCVrcV5nLx6mbU6ZJaimlJQamhgcl+Dg0dTbWNNoNf///+jl0Ief3V8AAAAHnRSTlMA/VRj9vr8Mw5uef75sNz5/tZahNr+u7k9/mL09ewQFWwFAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAQklEQVR4nB3GRxKAIBAAwSEpLCjmnP7/Si371IBHN7kFM/bhcg6me+hUXcEyGx88bKJFAOyj1qIE9mjjnzMdyX55AVwDAnzXIZPiAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./lib/pageConfig.js

// eslint-disable-next-line import/prefer-default-export
const config = {
    siteName: "Dr.Doc AI",
    blogTitle: "Blog",
    baseUrl: "drdoc.ai",
    websiteLogo: logo,
    twitterHandle: "@junaid_builds",
    twitterCardType: "Dr.Doc AI Blog",
    css: {
        primaryColor: "#111",
        accentColor: "#455A64",
        lightGray: "#eeeeee",
        backgroundColor: "#fff",
        black: "#111",
        white: "#fff",
        textColor: "#333",
        opacity: 0.7
    }
};
const privacy = {
    ...config,
    siteDescription: "Privacy policy for AI Doctor Documentation Tool ",
    defaultPageTitle: "Privacy | Dr.Doc AI"
};
const FAQ = {
    ...config,
    siteDescription: "Frequently asked questions for Dr.Doc AI",
    defaultPageTitle: "FAQ | Dr.Doc AI"
};
const landing = {
    ...config,
    siteDescription: "Dr.Doc AI will quickly transcribe and format your appointment notes with your exact format - in seconds.",
    defaultPageTitle: "AI Clinical Documentation | Dr.Doc AI "
};
const thankYou = {
    ...config,
    siteDescription: "Dr.Doc AI will quickly transcribe and format your appointment notes with your exact format - in seconds.",
    defaultPageTitle: "Get In Touch | Dr.Doc AI"
};
const blogHome = {
    ...config,
    siteDescription: "Dr.Doc AI will quickly transcribe and format your appointment notes with your exact format - in seconds.",
    defaultPageTitle: "Blog | Dr.Doc AI"
};
const configSet = {
    FAQ,
    privacy,
    landing,
    blogHome,
    thankYou
};


/***/ }),

/***/ 1673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages_Home; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./utils/seo.js
var seo = __webpack_require__(3298);
// EXTERNAL MODULE: ./lib/pageConfig.js + 1 modules
var pageConfig = __webpack_require__(3517);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./components/head.jsx


function HeadComponent() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                src: "https://cdnjs.cloudflare.com/ajax/libs/three.js/r134/three.min.js",
                async: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                src: "https://cdn.jsdelivr.net/npm/vanta/dist/vanta.waves.min.js",
                async: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                src: "https://embed.typeform.com/next/embed.js",
                async: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "viewport",
                content: "minimum-scale=1, initial-scale=1, width=device-width"
            }),
             true && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        strategy: "afterInteractive",
                        dangerouslySetInnerHTML: {
                            __html: '\n          (function(c,l,a,r,i,t,y){\n            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};\n            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;\n            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);\n        })(window, document, "clarity", "script", "duvu3rlmwn");'
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        async: true,
                        src: "https://www.googletagmanager.com/gtag/js?id=G-30037DH1EH"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        dangerouslySetInnerHTML: {
                            __html: "\n        window.dataLayer = window.dataLayer || [];\n        function gtag(){dataLayer.push(arguments);}\n        gtag('js', new Date());\n        gtag('config', 'G-30037DH1EH');\n      "
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        strategy: "afterInteractive",
                        dangerouslySetInnerHTML: {
                            __html: "\n              !function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments); },s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='https://static.ads-twitter.com/uwt.js', a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script'); twq('config','ofdgw');"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "180x180",
                href: "/apple-touch-icon.png"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "16x16",
                href: "/favicon.ico"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "manifest",
                href: "/site.webmanifest"
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/container/base.jsx + 3 modules
var base = __webpack_require__(5216);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-flip-move/dist/react-flip-move.es.js
var react_flip_move_es = __webpack_require__(7794);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/esm/CheckIcon.js
var CheckIcon = __webpack_require__(4589);
;// CONCATENATED MODULE: ./components/landing/marquee.jsx




function Carousel() {
    const initialItems = [
        {
            name: "Tom Belfort",
            time: "12:01 PM",
            date: "26/5/2023"
        },
        {
            name: "Zig Ziglar",
            time: "12:16 PM",
            date: "27/5/2023"
        },
        {
            name: "Aaron Ross",
            time: "12:46 PM",
            date: "28/5/2023"
        },
        {
            name: "Mary Ash",
            time: "1:01 PM",
            date: "29/5/2023"
        }
    ];
    const [items, setItems] = (0,react.useState)(initialItems);
    const [counter, setCounter] = (0,react.useState)(2);
    (0,react.useEffect)(()=>{
        const interval = setInterval(()=>{
            setItems((prevItems)=>{
                const newItems = [
                    ...prevItems
                ];
                const lastItem = newItems.pop();
                return [
                    lastItem,
                    ...newItems
                ];
            });
        }, 3000);
        return ()=>clearInterval(interval);
    }, []);
    (0,react.useEffect)(()=>{
        const interval = setInterval(()=>{
            setCounter((prevCounter)=>{
                return prevCounter >= 7 ? 2 : prevCounter + 1;
            });
        }, 500);
        return ()=>clearInterval(interval);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "lg:h-[50vh] max-w-md mx-auto overflow-hidden",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flip_move_es/* default */.Z, {
            children: items.map((item, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mb-4 p-4 border border-gray-100 bg-white shadow-sm rounded-lg grid grid-cols-5 justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-span-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-xl font-header",
                                    children: idx < 1 ? "Incoming Patient" : idx < 2 ? "Appointment" : idx < 3 ? "Transcribing Notes" : "Formatted Docs"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-gray-400 text-sm mt-3 font-header",
                                    children: idx < 2 ? "".concat(item.name, " at ").concat(item.time) : idx < 3 ? "".concat(counter, " items added to SOAP ") : "Added to EMR"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-span-2",
                            children: idx < 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "font-semibold text-center bg-zinc-300 rounded-lg p-4 w-42",
                                children: "Incoming -"
                            }) : idx < 2 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "font-semibold text-center bg-zinc-300 rounded-lg p-4 w-42",
                                children: "Consulting..."
                            }) : idx < 3 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "font-semibold items-center justify-center bg-blue-500 text-white rounded-lg p-4 flex flex-row gap-2",
                                children: [
                                    "Formatting",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        className: "animate-spin h-5 w-5 self-center",
                                        fill: "currentColor",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 0 40 40",
                                        enableBackground: "new 0 0 40 40",
                                        xml: "preserve",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                opacity: "0.2",
                                                d: "M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946 s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634 c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0 C22.32,8.481,24.301,9.057,26.013,10.047z"
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "font-semibold items-center justify-center bg-green-500 text-white rounded-lg p-4 flex flex-row gap-2",
                                children: [
                                    "Automated",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIcon/* default */.Z, {
                                        className: "h-6 w-6"
                                    })
                                ]
                            })
                        })
                    ]
                }, item.name))
        })
    });
}

;// CONCATENATED MODULE: ./components/landing/hero.jsx




function Hero() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative isolate overflow-hidden bg-gradient-to-b from-indigo-100/20",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mx-auto max-w-7xl pb-24 pt-10 sm:pb-32 lg:grid lg:grid-cols-2 lg:gap-x-8 lg:px-8 lg:py-40",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "px-6 lg:px-0 lg:pt-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mx-auto max-w-2xl",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "max-w-lg",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                className: "text-5xl font-header tracking-tight text-gray-900 sm:text-7xl",
                                                children: "Docs for Docs: Making Paperwork Painless."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "mt-6 text-lg leading-8 text-gray-600",
                                                children: "Dr.Doc AI will transcribe and document your appointment notes with SOAP style - in 3 seconds."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mt-10 flex flex-col md:flex-row items-center gap-x-6 gap-y-6 md:gap-y-0",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "https://client.drdoc.ai/register",
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        className: "w-max border border-gray-800 hover:text-gray-900 rounded-md px-6 py-2 bg-gray-900 text-white hover:bg-white",
                                                        children: "Get Free Access Now"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/demo",
                                                        className: "font-medium w-max border-2 border-drDocBlue hover:text-gray-900 rounded-md px-6 py-2 bg-blue-50 text-drDocBlue hover:bg-gray-50",
                                                        children: "Get a Demo"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mt-20 sm:mt-24 md:mx-auto md:max-w-2xl lg:mx-0 lg:mt-0 lg:w-screen",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute inset-y-0 right-1/2 -z-10 -mr-10 w-[200%] skew-x-[-30deg] bg-white shadow-xl shadow-DrDocBlue-600/10 ring-1 ring-blue-50 md:-mr-20 lg:-mr-36",
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel, {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute inset-x-0 bottom-0 -z-10 h-24 bg-gradient-to-t from-white sm:h-32"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-drDocBlue",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "max-w-7xl mx-auto p-6 flex flex-row gap-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/quote.png",
                            className: "h-5 w-5",
                            alt: "Quotation mark"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "font-medium text-lg text-white",
                            children: [
                                "“Saves countless hours... [Dr.Doc AI] has greatly improved my patients clinic experience & freed up my time to spend with my family and friends.",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "italic",
                                    children: "- Shahbaz Malik, MD"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/esm/ChatBubbleLeftRightIcon.js
var ChatBubbleLeftRightIcon = __webpack_require__(2418);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/esm/GlobeAltIcon.js
var GlobeAltIcon = __webpack_require__(7950);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/esm/UsersIcon.js
var UsersIcon = __webpack_require__(7543);
;// CONCATENATED MODULE: ./components/landing/features.jsx



const features = [
    {
        name: "Faster Documentation",
        description: "Save hours every day as AI quickly documents your prompts into SOAP.",
        icon: ChatBubbleLeftRightIcon/* default */.Z
    },
    {
        name: "Accurate, Comprehensive Notes",
        description: "No key details missed; NLP AI will learn from your SOAPs to make perfect notes.",
        icon: GlobeAltIcon/* default */.Z
    },
    {
        name: "Improved Work-Life Balance",
        description: "Doctors' lives transformed as clinic work is completed in the clinic.",
        icon: UsersIcon/* default */.Z
    }
];
function Features() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "features",
        className: "bg-white pt-24 sm:pt-32",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mx-auto max-w-7xl px-6 lg:px-8",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-4xl font-header tracking-tight text-gray-900 sm:text-6xl text-center",
                    children: "Transform Your Evenings"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-auto mt-20 max-w-2xl lg:max-w-none",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("dl", {
                        className: "grid max-w-xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-3",
                        children: features.map((feature)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col h-full justify-between p-4 py-6 rounded-xl bg-white ",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("dt", {
                                        className: "font-semibold flex flex-col items-center justify-center leading-7 text-zinc-900 text-2xl",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-blue-50",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(feature.icon, {
                                                    className: "h-12 w-12 text-drDocBlue",
                                                    "aria-hidden": "true"
                                                })
                                            }),
                                            feature.name
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                        className: "mt-5 flex flex-auto flex-col items-center justify-center text-center text-lg leading-7 text-zinc-600",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "h-max",
                                            children: feature.description
                                        })
                                    })
                                ]
                            }, feature.name))
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "hidden lg:flex mx-auto mt-20 max-w-2xl lg:max-w-none flex justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/demo.gif",
                        alt: "Demo gif of product"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "lg:hidden mx-auto mt-20 max-w-2xl lg:max-w-none flex justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/demo.gif",
                        alt: "Demo gif of product"
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./components/landing/price.jsx


const includedFeatures = [
    "12 appointments free each month",
    "AI that learn your unique SOAP style",
    "Secure and encrypted note history",
    "Documentation done in seconds"
];
function Example() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "price",
        className: " relative isolate bg-white py-24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute inset-x-0 -top-3 -z-10 transform-gpu overflow-hidden px-36 blur-3xl",
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-auto aspect-[1155/678] w-[72.1875rem] bg-gradient-to-tr from-[#ff80b5] to-[#F67F0A] opacity-30",
                    style: {
                        clipPath: "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mx-auto max-w-7xl px-6 lg:px-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mx-auto max-w-3xl sm:text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-4xl font-header tracking-tight text-gray-900 sm:text-6xl",
                            children: "Clinical Documentation for 88% less cost compared to Dragon One!"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mx-auto mt-16 max-w-2xl rounded-3xl ring-1 ring-gray-200 sm:mt-20 lg:mx-0 lg:flex lg:max-w-none",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "p-8 sm:p-10 lg:flex-auto",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "text-2xl font-bold tracking-tight text-gray-900",
                                        children: "Simple no-tricks pricing"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mt-6 text-base leading-7 text-gray-600",
                                        children: "Dr.Doc AI system outperforms traditional clinical documentation tools available using natural language processing. - Letting physicians to focus on what matters most."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mt-10 flex items-center gap-x-4",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                className: "flex-none text-sm font-semibold leading-6 text-zinc-700",
                                                children: "What's included"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "h-px flex-auto bg-zinc-400"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        role: "list",
                                        className: "mt-8 grid grid-cols-1 gap-4 text-sm leading-6 text-gray-600 sm:grid-cols-2 sm:gap-6",
                                        children: includedFeatures.map((feature)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                className: "flex gap-x-3",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIcon/* default */.Z, {
                                                        className: "h-6 w-5 flex-none text-drDocBlue",
                                                        "aria-hidden": "true"
                                                    }),
                                                    feature
                                                ]
                                            }, feature))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "-mt-2 p-2 lg:mt-0 lg:w-full lg:max-w-md lg:flex-shrink-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "rounded-2xl bg-gray-50 py-10 text-center ring-1 ring-inset ring-gray-900/5 lg:flex lg:flex-col lg:justify-center lg:py-16",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mx-auto max-w-xs px-8",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-base font-semibold text-gray-600",
                                                children: "Early Access Pricing"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "mt-6 flex items-baseline justify-center gap-x-2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-5xl font-bold tracking-tight text-gray-900",
                                                        children: "$35"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-sm font-semibold leading-6 tracking-wide text-gray-600",
                                                        children: "/ month"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "https://client.drdoc.ai/register",
                                                target: "_blank",
                                                rel: "noreferrer",
                                                className: "mt-10 block w-full rounded-md px-3 py-2 border border-gray-800 hover:text-gray-900 bg-gray-900 text-white hover:bg-white text-center font-semibold shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ",
                                                children: "Get Free Access"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "mt-6 text-xs leading-5 text-gray-600",
                                                children: "Invoices and receipts available for easy company reimbursement."
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/landing/index.jsx
//COMPONENTS





function Home() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "h-full w-full bg-white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(base/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Features, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Example, {})
            ]
        })
    });
}

;// CONCATENATED MODULE: ./pages/index.js





// COMPONENTS


var __N_SSG = true;
function pages_Home(param) {
    let { articles =[]  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "font-copy bg-black min-h-screen",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadComponent, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                ...(0,seo/* createSEOPageConfig */.Cd)(pageConfig/* configSet.landing */.r.landing)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Home, {})
        ]
    });
}


/***/ }),

/***/ 3298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cd": function() { return /* binding */ createSEOPageConfig; },
/* harmony export */   "JV": function() { return /* binding */ BlogSeo; },
/* harmony export */   "WQ": function() { return /* binding */ createSEOConfig; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3517);



const getImage = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (data.imageUrl) {
        return [
            {
                url: data.imageUrl,
                width: 600,
                height: 300,
                alt: data.title
            }
        ];
    }
    if (data.slug) {
        return [
            {
                url: "/api/blog-image/".concat(data.slug),
                width: 600,
                height: 300,
                alt: data.title
            }
        ];
    }
    return [
        {
            url: _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.websiteLogo */ .v.websiteLogo,
            width: 280,
            height: 280,
            alt: "JRO"
        }
    ];
};
function BlogSeo(param) {
    let { data  } = param;
    if (!data) return null;
    const description = data.seoDescription ? data.seoDescription : _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.siteDescription */ .v.siteDescription;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .ArticleJsonLd */ .dX, {
        url: data.canonicalUrl,
        title: data.title,
        images: getImage(data).map((file)=>file.url),
        datePublished: data.publishDate,
        dateModified: data.modifiedDate,
        authorName: _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.author */ .v.author,
        publisherName: _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.author */ .v.author,
        publisherLogo: "https://www.example.com/photos/logo.jpg",
        description: description
    });
}
function createSEOConfig() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const title = data.title || _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.defaultPageTitle */ .v.defaultPageTitle;
    const description = data.seoDescription ? data.seoDescription : _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.siteDescription */ .v.siteDescription;
    return {
        title,
        description,
        openGraph: {
            type: "website",
            locale: "en_US",
            url: data.canonicalUrl,
            title,
            description,
            images: getImage(data),
            site_name: _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.siteName */ .v.siteName
        },
        twitter: {
            handle: _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.twitterHandle */ .v.twitterHandle,
            site: _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.twitterHandle */ .v.twitterHandle,
            cardType: _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.twitterCardType */ .v.twitterCardType
        }
    };
}
function createSEOPageConfig() {
    let config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!config) return null;
    const title = config.defaultPageTitle;
    const description = config.siteDescription;
    return {
        title,
        description,
        openGraph: {
            type: "website",
            locale: "en_US",
            url: config.canonicalUrl,
            title,
            description,
            images: getImage(config),
            site_name: config.siteName
        },
        twitter: {
            handle: config.twitterHandle,
            site: config.twitterHandle,
            cardType: config.twitterCardType
        }
    };
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [228,962,444,216,774,888,179], function() { return __webpack_exec__(5557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);